export default {
    ADICIONAR_ANEXO_DADOS_GERAIS: 'adicionarAnexoDadosGerais',
    ADICIONAR_DOCUMENTO_SOLICITADO: 'adicionarDocumentoSolcitado',
    ADICIONAR_EMAIL_CONVIDADO: 'adicionarEmailConvidado',
    ADICIONAR_LINHA_DE_FORNECIMENTO: 'adicionarLinhaDeFornecimento',
    ALTERAR_EXCLUSIVIDADE: 'alterarExclusivade',
    ALTERAR_EXCLUSIVIDADE_ITEM: 'alterarExclusivadeItem',
    ALTERAR_EXCLUSIVIDADE_LOTE: 'alterarExclusivadeLote',
    ALTERAR_SITUACAO_DE_ITEM_E_LOTE: 'alterarSituacaoDeItemELote',
    ATUALIZAR_SESSAO_DOMINIO: 'atualizarSessaoDominio',
    ATUALIZAR_SESSAO_DOMINIO_UNICO: 'atualizarSessaoDominioUnico',
    ATUALIZAR_TIPO_ANEXO_DADOS_GERAIS: 'atualizarTipoAnexoDadosGerais',
    BAIXAR_RELATORIO_DA_ATA_DA_COMPRA_DIRETA: 'baixarRelatorioDaAtaDaCompraDireta',
    BUSCAR_CONVIDADOS_DA_COMPRA_DIRETA: 'buscarConvidadosDaCompraDireta',
    BUSCAR_DADOS_GERAIS: 'buscarDadosGerais',
    BUSCAR_DOCUMENTOS: 'buscarDocumentos',
    BUSCAR_DOCUMENTOS_PROPOSTA: 'buscarDocumentosProposta',
    BUSCAR_DOCUMENTOS_SOLICITADOS: 'buscarDocumentosSolicitados',
    BUSCAR_DOMINIO_PERFIL_USUARIO: 'buscarDominioPerfilUsuario',
    BUSCAR_LINHAS_DE_FORNECIMENTO: 'buscarLinhasDeFornecimento',
    BUSCAR_LINHAS_DE_FORNECIMENTO_DA_COMPRA_DIRETA: 'buscarLinhasDeFornecimentoDaCompraDireta',
    BUSCAR_LINK_EDITAR_USUARIO: 'buscarLinkEditarUsuario',
    BUSCAR_ITENS_E_LOTES: 'buscarItensELotes',
    BUSCAR_PARAMETROS: 'buscarParametros',
    BUSCAR_PRODUTO_POR_NOME: 'buscarProdutoPorNome',
    BUSCAR_RESUMO_DA_COMPRA_DIRETA: 'buscarResumoDaCompraDireta',
    BUSCAR_RESUMO_ITEM_E_LOTE: 'buscarResumoItemELote',
    BUSCAR_USUARIO_LOGADO: 'buscarUsuarioLogado',
    BUSCAR_LINGUAGEM: 'buscarLinguagem',
    SUSPENDER_COMPRA_DIRETA: 'suspenderCompraDireta',
    RETOMAR_COMPRA_DIRETA: 'retomarCompraDireta',
    COMPRADOR: {
        ADICIONAR_DOCUMENTO_SEM_VINCULO: 'adicionarDocumentoSemVinculo',
        ADJUDICAR_FORNECEDOR: 'adjudicar',
        VERIFICAR_SALDO_SUBELEMENTO: 'verificarSaldoSubelemento',
        DECLARAR_FORNECEDOR_VENCEDOR: 'declararVencedor',
        ENVIAR_PARA_HOMOLOGACAO: 'enviarParaHomologacao',
        CANCELAR_ENVIO_PARA_HOMOLOGACAO: 'cancelarEnvioParaHomologacao',
        ATUALIZAR_ANALISE_DE_DOCUMENTO_SELECIONADO: 'atualizarAnaliseDeDocumentoSelecionado',
        SOLICITAR_ENVIO_DO_DOCUMENTO_SELECIONADO: 'solicitarEnvioDeDocumentoSelecionado',
        SOLICITAR_ASSINATURA_DO_DOCUMENTO_SELECIONADO: 'solicitarAssinaturaDoDocumentoSelecionado',
        BAIXAR_DOCUMENTO_DO_FORNECEDOR: 'baixarDocumentoDoFornecedor',
        BAIXAR_HISTORICO_DE_LANCES: 'baixarHistoricoDeLancesDoComprador',
        BAIXAR_RESULTADO_ITENS_E_LOTES: 'baixarResultadoItensLotes',
        BUSCAR_ANALISE_DOCUMENTOS_DO_FORNECEDOR: 'buscarAnaliseDocumentosDoFornecedor',
        BUSCAR_AUTOCOMPLETE_IMPORTAR_COMPRA_DIRETA: 'buscarAutocompleteImportarCompraDireta',
        BUSCAR_COMPRAS_DIRETAS_EM_ANDAMENTO: 'buscarComprasDiretasEmAndamentoDoComprador',
        BUSCAR_COMPRAS_DIRETAS_EM_ELABORACAO: 'buscarComprasDiretasEmElaboracaoDoComprador',
        BUSCAR_COMPRAS_DIRETAS_ENCERRADAS: 'buscarComprasDiretasEncerradasDoComprador',
        BUSCAR_DADOS_ACOMPANHAMENTO: 'buscarDadosAcompanhamentoDoComprador',
        BUSCAR_DOCUMENTOS_VIRTUALIZADOS: 'buscarDocumentosVirtualizados',
        BUSCAR_RESULTADO_ITENS_E_LOTES: 'buscarResultadoItensELotes',
        BUSCAR_TODAS_COMPRAS_DIRETAS: 'buscarTodasComprasDiretasDoComprador',
        BUSCAR_AVANCADA_COMPRAS_DIRETAS_COMPRADOR: 'buscarAvancadaComprasDiretasComprador',
        BUSCAR_SITUACAO_DOCUMENTOS_EDOCS: 'buscarSituacaoDocumentosEdocs',
        ACESSAR_EDOCS: 'acessarEdocs',
        DESCLASSIFICAR_FORNECEDOR: 'desclassificarFornecedor',
        INABILITAR_FORNECEDOR: 'inabilitarFornecedor',
        DESEMPATAR_FORNECEDORES: 'desempatar',
        DESEMPATAR_FORNECEDORES_ETAPA_FECHADA: 'desempatarFornecedoresEtapaFechada',
        DESEMPATAR_FORNECEDOR_MANUALMENTE: 'desenpactarFornecedorManualmente',
        IMPORTAR_ARQUIVO_DE_ITENS_E_LOTES: 'importarArquivoDeItensELotes',
        NEGOCIAR_ITEM_OU_LOTE: 'negociarItemOuLote',
        NOVA_COMPRA_DIRETA: 'novaCompraDireta',
        SALVAR_DADOS_GERAIS_NOVA_COMPRA: 'salvarDadosNovaCompra',
        ATUALIZAR_SITUACAO_ANEXO_COMPRA_DIRETA : 'atualizarSituacaoAnexoCompraDireta',
        BUSCAR_ORGAOS_DISPONIVEIS : 'buscarOrgaosDisponiveis',
        RECLASSIFICAR_FORNECEDOR: 'reclassificarFornecedor',
        HABILITAR_FORNECEDOR: 'habilitarFornecedor',
        BAIXAR_RELATORIO_CAPA_COMPRA_DIRETA: 'baixarRelatorioCapaCompraDireta',
        BAIXAR_RELATORIO_FORNECEDORES_NOTIFICADOS: 'baixarRelatorioFornecedoresNotificados',
        BAIXAR_RELATORIO_CAPA_COMPRA_DIRETA_END_POINT: 'baixarRelatorioCapaCompraDiretaEndPoint',
        BAIXAR_RELATORIO_FORNECEDORES_NOTIFICADOS_END_POINT: 'baixarRelatorioFornecedoresNotificadosEndPoint',
        BAIXAR_DOCUMENTO_COMPRA_DIRETA: 'baixarDocumentoCompraDireta',
        CANCELAR_ADJUDICACAO: 'cancelarAdjudicacao',
        CANCELAR_DECLARACAO_VENCEDOR: 'cancelarDeclaracaoVencedor',
        JUNTAR_DOCUMENTO_COMPRA_DIRETA: 'juntarDocumentosCompraDireta',
        VIRTUALIZAR_DOCUMENTO_COMPRA_DIRETA: 'virtualizarDocumentoCompraDireta',
        BUSCAR_INFORMACOES_SISTEMA: 'buscarDadosSistemasIntegrados',
        ENCERRAR_COMPRA_DIRETA: 'encerrarCompraDireta',
        DESPUBLICAR_COMPRA_DIRETA: 'despublicarCompraDireta',
        PRORROGAR_COMPRA_DIRETA: 'prorrogarCompraDireta',
        BUSCAR_EVENTOS_POS_PUBLICACAO: 'buscarEventosPosPublicacao',
        BUSCAR_REQUISICOES_POR_SISTEMA: 'buscarRequisicoesPorSistema',
        BUSCAR_REQUEST_BODY_DA_REQUISICAO: 'buscarRequestBodyDaRequisicao',
        BUSCAR_REQUISICOES_COM_ERRO_POR_SISTEMA: 'buscarRequisicoesComErroPorSistema',
        ATUALIZAR_REQUISICAO_HTTP: 'atualizarRequisicaoHttp',
        REENVIAR_REQUISICAO_HTTP: 'reenviarRequisicaoHttp',
        REVERTER_SITUACAO_ITEM_LOTE: 'reverterSituacaoItemLote',
        BAIXAR_TODOS_DOCUMENTOS_APRESENTADOS: 'baixarTodosDocumentosApresentados',
        BAIXAR_RELATORIO_PROPOSTAS_ITEM_LOTE: 'baixarRelatorioPropostasItemLote',
        ENVIAR_SOLICITACAO_REAJUSTE_ITEM_LOTE: 'enviarSolicitacaoReajusteItemLote',
        CANCELAR_NEGOCIACAO: 'cancelarNegociacao',
        BUSCAR_NOTIFICACOES_COMPRADOR: 'buscarNotificacoesComprador',
        BUSCAR_DESTINATARIO_CHAT_E_MENSAGENS: 'buscarDestinatarioChatEMensagens',
        BUSCAR_NOTIFICACOES_CHAT_COMPRADOR: 'buscarNotificacoesChatComprador',
        CONTAR_NOTIFICACOES_NAO_LIDAS_COMPRADOR: 'contarNotificacoesNaoLidasComprador',
        CONTAR_NOTIFICACOES_NAO_LIDAS_CHAT_COMPRADOR: 'contarNotificacoesNaoLidasChatComprador',
        BAIXAR_DOCUMENTOS_EM_LOTE: 'baixarDocumentosEmLote',
        JUNTAR_DOCUMENTOS_EM_LOTE: 'juntarDocumentosEmLote',
        INICIAR_ASSINATURA_DOCUMENTOS_EM_LOTE: 'iniciarAssinaturaDocumentosEmLote',
        FINALIZAR_ASSINATURA_DOCUMENTOS_EM_LOTE: 'finalizarAssinaturaDocumentosEmLote',
        ADICIONAR_MODALIDADE_INDICE_PRECO: 'adicionarModalidadeIndicePreco',
        REMOVER_REAJUSTE_INDICE_PRECO: 'removerReajusteIndicePreco',
        BUSCAR_ULTIMO_REAJUSTE_POR_MODALIDADE: 'buscarUltimoReajustePorModalidade',
        BUSCAR_MODALIDADE_INDICE_PRECO: 'buscarModalidadeIndicePreco',
        CRIAR_REAJUSTE_INDICE_PRECO: 'criarReajusteIndicePreco',
        BUSCAR_HISTORICO_REAJUSTE_POR_MODALIDADE: 'buscarHistoricoReajustePorModalidade',
        ATUALIZAR_PERCENTUAL_REAJUSTE: 'atualizarPercentualReajuste',
        SALVAR_REAJUSTE_INDICE_PRECO_EM_MASSA: 'salvarReajusteIndicePrecoEmMassa',
        BAIXAR_TERMO_HOMOLOGACAO: 'baixarTermoHomologacao',
        BUSCAR_CONFIGURACAO_PRAZO_INCISOS: 'buscarConfiguracaoPrazoIncisos',
        REMOVER_CONFIGURACAO_PRAZO_INCISO: 'removerConfiguracaoPrazoInciso',
        BUSCAR_AMPAROS_LEGAIS_HIERARQUICO: 'buscarAmparosLegaisHierarquico',
        CADASTRAR_CONFIGURACAO_PRAZO_INCISO: 'cadastrarConfiguracaoPrazoInciso',
        ATUALIZAR_CONFIGURACAO_PRAZO_INCISO: 'atualizarConfiguracaoPrazoInciso',
        REMOVER_REQUISICAO_COM_ERRO: 'removerRequisicaoComErro',
        DESENTRANHAR_DOCUMENTO_VIRTUALIZADO: 'desentranharDocumentoVirtualizado',
        DESENTRANHAR_DOCUMENTO_VIRTUALIZADOV2: 'desentranharDocumentoVirtualizadoV2',
        BUSCAR_DOCUMENTO_EDITOR_TEXTO_POR_ID: 'buscarDocumentoEditorTextoPorId',
        SINCRONIZAR_DOCUMENTO_EDITOR_TEXTO: 'sincronizarDocumentoEditorTexto',
        BUSCAR_INFOS_DOC_DESENTRANHAMENTO: 'buscarInfosDocDesentranhamento',
        REORDENAR_DOCUMENTO_VIRTUALIZADO: 'reordenarDocumentoVirtualizado',
        CANCELAMENTO_DOCUMENTO_VIRTUALIZADO: 'cancelarDocumentoVirtualizado',
        VALIDAR_PARA_PROPOSTA: 'validarParaPropostaComprador',
        BUSCAR_TERMOS: 'buscarTermosDoFornecedorComprador',
        CRIAR_TERMOS: 'criarTermosDoFornecedorComprador',
        SALVAR_TERMOS: 'salvarTermosDoFornecedorComprador',
        BUSCAR_DETALHES_DA_COMPRA_DIRETA: 'buscarDetalhesDaCompraDiretaDoFornecedorComprador',
        BUSCAR_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA: 'buscarResumoDaCompraDiretaNaPropostaComprador',
        BUSCAR_ITENS_E_LOTES_DA_PROPOSTA: 'buscarItensELotesDaPropostaDoFornecedorComprador',
        SALVAR_ITEM_DA_PROPOSTA: 'salvarValorDaPropostaDoFornecedorComprador',
        BUSCAR_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA: 'buscarDocumentosSolicitadosDaPropostaComprador',
        ADICIONAR_ANEXO_DOCUMENTO_SOLICITADO_DA_PROPOSTA: 'adicionarAnexoDocumentoSolicitadoDaPropostaComprador',
        REMOVER_DOCUMENTO_APRESENTADO: 'removerDocumentoApresentadoComprador',
        ATUALIZAR_LOTE_PROPOSTA_MAIOR_DESCONTO: 'atualizarLotePropostaMaiorDescontoComprador',
        ENVIAR_PROPOSTA: 'enviarPropostaDoFornecedorComprador',
        RANKEAR_PROPOSTAS: 'rankearPropostasComprador',
        INSERIR_REAJUSTE_PROPOSTAS: 'inserirReajustePropostasComprador',
        ENVIAR_DOCUMENTOS_ANALISE: 'enviarDocumentosAnaliseComprador',
        REMOVER_PROPOSTA: 'removerPropostaDoFornecedorComprador',
        BUSCAR_LISTAGEM_PAGINADA: 'buscarListagemPaginadaFornecedorComprador',
        ENVIAR_REAJUSTE_LOTE:'enviarReajusteLoteDoFornecedorComprador',
    },
    AUTORIDADE_SUPERIOR: {
        BUSCAR_COMPRAS_DIRETAS_HOMOLOGACAO: 'buscarComprasDiretasHomologacao',
        DEVOLVER_ITEM_LOTE: 'devolverItemLote',
    },
    EXPORTAR_COMPRA_DIRETA: 'exportarCompraDireta',
    EXPORTAR_RESULTADOS_COMPRAS_PREPARACAO: 'exportarResultadosComprasPreparacao',
    EXPORTAR_COMPRA_DIRETA_ARQUIVO: 'exportarCompraDiretaArquivo',
    EXPORTAR_COMPRA_DIRETA_MAIS_BRASIL: 'exportarCompraDiretaMaisBrasil',
    BAIXAR_RELATORIO_MAIS_BRASIL: 'baixarRelatorioMaisBrasil',
    FORMATAR_LISTA_DE_ITENS_E_LOTES: 'formatarListaDeItensELotes',
    FORNECEDOR: {
        ADICIONAR_ANEXO_DOCUMENTO_SOLICITADO_DA_PROPOSTA: 'adicionarAnexoDocumentoSolicitadoDaProposta',
        ATUALIZAR_VALOR_INSERIDO_PARA_LANCE: 'atualizarValorInseridoParaLance',
        BAIXAR_RELATORIO_DE_PROTOCOLOS: 'baixarRelatorioDeProtocolos',
        BAIXAR_RELATORIO_DE_PROTOCOLO_PREVIEW: 'baixarRelatorioProtocoloPreview',
        BAIXAR_RELATORIO_DE_REAJUSTES: 'baixarRelatorioDeReajustes',
        BAIXAR_RELATORIO_DE_REAJUSTES_NAO_VIRTUALIZADO: 'baixarRelatorioDeReajustesNaoVirtualizado',
        BUSCAR_COMPRAS_DIRETAS_ENCERRADAS: 'buscarComprasDiretasEncerradasDoFornecedor',
        BUSCAR_COMPRAS_DIRETAS_DISPONIVEIS: 'buscarComprasDiretasDisponiveis',
        BUSCAR_DETALHES_DA_COMPRA_DIRETA: 'buscarDetalhesDaCompraDiretaDoFornecedor',
        BUSCAR_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA: 'buscarDocumentosSolicitadosDaProposta',
        BUSCAR_ITENS_E_LOTES_DA_PROPOSTA: 'buscarItensELotesDaPropostaDoFornecedor',
        BUSCAR_ITENS_E_LOTES_VENCEDORES_A_REAJUSTAR: 'buscarItensELotesVencedoresAReajustar',
        BUSCAR_LANCES_DA_COMPRA_DIRETA: 'buscarLancesDaCompraDireta',
        BUSCAR_MEUS_LOTES_E_ITENS_VENCEDORES: 'buscarMeusLotesEItensVencedoresDoFornecedor',
        BUSCAR_MINHAS_COMPRAS_DIRETAS: 'buscarMinhasComprasDiretas',
        BUSCAR_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR: 'buscarAvancadaComprasDiretasFornecedor',
        BUSCAR_COMPRAS_DIRETAS_MEU_INTERESSE: 'buscarComprasDiretasMeuInteresse',
        BUSCAR_RESULTADO_DE_TODOS_LOTES_E_ITENS: 'buscarResultadoDeTodosLotesEItensDoFornecedor',
        BUSCAR_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA: 'buscarResumoDaCompraDiretaNaProposta',
        BUSCAR_TERMOS: 'buscarTermosDoFornecedor',
        CRIAR_TERMOS: 'criarTermosDoFornecedor',
        CANCELAR_ENVIO_DA_PROPOSTA_SEM_DISPUTA: 'cancelarEnvioDePropostaSemDisputa',
        CANCELAR_ENVIO_DA_PROPOSTA_COM_DISPUTA: 'cancelarEnvioDePropostaComDisputa',
        CANCELAR_LANCE: 'cancelarLanceDoFornecedor',
        CANCELAR_LANCE_DESEMPATE: 'cancelarLanceDesempateDoFornecedor',
        DECIDIR_NEGOCIACAO_LOTE_OU_ITEM_DO_REAJUSTE: 'decidirNegociacaoItemDoReajuste',
        EFETUAR_LANCE: 'efetuarLance',
        EFETUAR_LANCE_DESEMPATE: 'efetuarLanceDesempate',
        ENVIAR_PROPOSTA: 'enviarPropostaDoFornecedor',
        ENVIAR_REAJUSTE_LOTE:'enviarReajusteLoteDoFornecedor',
        ENVIAR_DOCUMENTOS_ANALISE: 'enviarDocumentosAnalise',
        REMOVER_PROPOSTA: 'removerPropostaDoFornecedor',
        REMOVER_DOCUMENTO_APRESENTADO: 'removerDocumentoApresentado',
        SALVAR_TERMOS: 'salvarTermosDoFornecedor',
        SALVAR_ITEM_DO_REAJUSTE: 'salvarItemDoReajusteDoFornecedor',
        SALVAR_ITEM_DA_PROPOSTA: 'salvarValorDaPropostaDoFornecedor',
        VERIFICAR_SE_POSSUI_LOTE_ITEM_VENCEDOR: 'verificarSePossuiLoteItemVencedorDoFornecedor',
        VALIDAR_PARA_PROPOSTA: 'validarParaProposta',
        ATUALIZAR_LOTE_PROPOSTA_MAIOR_DESCONTO: 'atualizarLotePropostaMaiorDesconto',
        BAIXAR_TERMO_ACEITE_PROPOSTA: 'baixarTermoAceiteProposta',
        BAIXAR_RELATORIO_TERMO_VIRTUALIZADO: 'baixarRelatorioTermoVirtualizado',
        ATUALIZAR_READEQUACAO_ITEM_LOTE: 'atualizarReadequacaoItemLote',
        BUSCAR_NOTIFICACOES_FORNECEDOR: 'buscarNotificacoesFornecedor',
        BUSCAR_NOTIFICACOES_CHAT_FORNECEDOR: 'buscarNotificacoesChatFornecedor',
        CONTAR_NOTIFICACOES_NAO_LIDAS_FORNECEDOR: 'contarNotificacoesNaoLidasFornecedor',
        CONTAR_NOTIFICACOES_NAO_LIDAS_CHAT_FORNECEDOR: 'contarNotificacoesNaoLidasChatFornecedor',
        BUSCAR_CONVERSACAO_CHAT_MENSAGENS: 'buscarConversacaoChatEMensagensFornecedor',
        BUSCAR_ITEM_LOTE_LANCES_DESEMPATE: 'buscarItemLoteLancesDesempate',
    },
    IMPORTAR_PROCESSO: 'importarProcesso',
    REIMPORTAR_PROCESSO: 'reimportarProcesso',
    REMOVER_ANEXO_DADOS_GERAIS: 'removerAnexoDadosGerais',
    REMOVER_COMPRA_DIRETA: 'removerCompraDireta',
    REMOVER_DOCUMENTO_SOLICTADO: 'removerDocumentoSolictado',
    REMOVER_EMAIL_CONVIDADO: 'removerEmailConvidado',
    REMOVER_ITEM_OU_LOTE: 'removerItemOuLote',
    REMOVER_ITEM: 'removerItem',
    REMOVER_LOTE: 'removerLote',
    REMOVER_LINHA_FORNECIMENTO: 'removerLinhaFornecimento',
    SALVAR_DADOS_GERAIS: 'salvarDadosGerais',
    SALVAR_ITENS_E_LOTES: 'salvarItensELotes',
    PUBLICAR_COMPRA_DIRETA: 'publicarCompraDireta',
    EXIBIR_NO_PNCP: 'exibirNoPncp',
    UPLOAD_ARQUIVO_SEM_LOKI: 'uploadArquivoSemLoki',
    DOWNLOAD_ANEXO: 'downloadAnexo',
    BAIXAR_DOCUMENTO_VIRTUALIZADO: 'baixarDocumentoVirtualizado',
    MARCAR_NOTIFICACAO_LIDA: 'marcarNotificacaoLida',
    MARCAR_NOTIFICACAO_MENSAGEM_LIDA: 'marcarNotificacaoMensagemLida',
    BUSCAR_UMA_UNICA_NOTIFICACAO: 'buscarUmaUnicaNotifificao',
    BUSCAR_UMA_UNICA_NOTIFICACAO_CHAT: 'buscarUmaUnicaNotifificaoChat',
    CONTAR_MENSAGENS_PARA_CENTRAL_CHAT: 'contarMensagensParaCentralChat',
    CONTAR_MENSAGENS_NAO_LIDAS_ITENS_LOTES: 'contarMensagensNaoLidasItensLotes',
    MARCAR_MENSAGENS_LIDAS_ITENS_LOTES: 'marcarMensagensLidasItensLotes',
    ESFINGE: {
        ENVIAR_DISPENSA: 'enviarDispensa',
        ALTERAR_DISPENSA: 'alterarDispensa',
        BUSCAR_DISPENSA: 'buscarDispensa',
        CANCELAR_DISPENSA: 'cancelarDispensa',
        ENVIAR_OCORRENCIA: 'enviarOcorrencia',
        ALTERAR_OCORRENCIA: 'alterarOcorrencia',
        BUSCAR_OCORRENCIA: 'buscarOcorrencia',
        BUSCAR_LISTAGEM_PAGINADA_PROTOCOLOS_OCORRENCIA: 'buscarListagemPaginadaProtocolosOcorrencia',
        CANCELAR_OCORRENCIA: 'cancelarOcorrencia',
    },
    LEGADO: {
        BUSCAR_LISTAGEM_PROCESSO: 'buscarListagemProcessoLegado',
        BUSCAR_PROCESSO_POR_ID: 'buscarProcessoPorIdLegado',
        BUSCAR_EXECUCOES_POR_PROCESSO: 'buscarExecucoesPorProcessoLegado',
        BUSCAR_ITENS_LOTES: 'buscarItensELotesLegado',
        BUSCAR_RESULTADO_EXECUCAO: 'buscarResultadoExecucaoLegado',
        BAIXAR_RELATORIO_PROPOSTAS_ITEM_LOTE_LEGADO: 'baixarRelatorioPropostasItemLoteLegado',
    }
}
